import React from "react";
import CSSModules from "lib/utils/css-modules";
import StWidget, { widgetJsCode, widgetComponentCode, oldwidgetJsCode } from "./StWidget";
import { Button, Form, FormControl, Grid, AppSettings, st } from "lib/index";
import "./widgets.css";

import styles from "./WidgetsSettingsView.less";

@CSSModules(styles)
export default class IndexWidgetView extends React.PureComponent {
  copyCode() {
    /* Get the text field */
    var copyText = document.getElementById("widgetCodeHidden");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/

    /* Copy the text inside the text field */
    document.execCommand("copy");

    /* Alert the copied text */
    alert(I18n.t("papp.settings.IndexWidgetsView.widgetCodeHasBeenCopied"));
  }
  render() {
    return (
      <div>
        <div className="widget-overview">
          <h2>{I18n.t("papp.settings.IndexWidgetsView.header1")}</h2>
          <p>{I18n.t("papp.settings.IndexWidgetsView.text1")}</p>
          <p>{I18n.t("papp.settings.IndexWidgetsView.text2")}</p>
        </div>
        <div styleName="widget-container">
          <textarea id="widgetCodeHidden">{widgetJsCode}</textarea>
          <FormControl.TextArea
            disabled="disabled"
            style={{ width: "600px" }}
            rows="13"
            defaultValue={widgetJsCode}
            id="widgetCode"
          />
          <br />
          <Button as="a" basic onClick={() => this.copyCode()}>
            <i className="far fa-copy"></i> {I18n.t("papp.settings.IndexWidgetsView.copyWidgetCode")}
          </Button>

          <hr />
        </div>
        <div className="widget-overview">
          <h2>{I18n.t("papp.settings.IndexWidgetsView.header2")}</h2>
          <p>{I18n.t("papp.settings.IndexWidgetsView.text3")}</p>
          <p>{I18n.t("papp.settings.IndexWidgetsView.text4")}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/WidgetsSettingsView/IndexWidgetView.jsx